var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.resetuser && _vm.message
      ? _c(
          "div",
          { staticClass: "notification is-light", class: _vm.messageType },
          [_vm._v(" " + _vm._s(_vm.message) + " ")]
        )
      : _vm._e(),
    _vm.resetuser && _vm.active
      ? _c(
          "div",
          [
            _vm._m(0),
            _vm.user
              ? _c("form-user-invite", {
                  attrs: {
                    fetching: _vm.fetching,
                    message: _vm.message,
                    "message-type": _vm.messageType,
                  },
                  on: { submit: _vm.complete },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("h1", { staticClass: "title is-bold" }, [_vm._v("Create a password")]),
      _c("p", [
        _vm._v(
          " You’ll use your email address to log in. If you need to, you can change your email address after you've completed registration. "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }